import axios from "axios";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { batch, connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  closeSlider,
  fetchData,
  openSlider,
} from "../../../../_actions/sidebarSliderActions";
import {
  setCounter,
  updateStoryMusic,
  uploadFile,
} from "../../../../_actions/storiesActions";
import {
  ADD_MASK,
  REPLACE_BKG_IMAGE,
  REPLACE_META,
} from "../../../../_actions/types";
import SearchForm from "../../../common/SearchForm";
import {
  wsAddLayer,
  wsAddMusic,
  wsUpdateMusic,
} from "../../../../_actions/webSocketAction";
import {
  analyticsTrackEvent,
  onClickSetAsBackground,
  prepareAssetPayload,
} from "../../../../_utils/common";
import {
  ASSET_MAX_FILE_UPLOAD_SIZE,
  AssetProcessingStatusTypes,
  ASSETS_ALLOWED_FILE_EXTENSIONS,
  DEFAULT_ARTBOARD_DURATION,
} from "../../../../_utils/constants";
import { ImageItem, ShowNoContent } from "../../../common/statelessView";
import TldrDropzone from "../../../common/TldrDropzone";
import TLDRInfiniteGalleryGridLayout from "../../../common/TLDRInfiniteGalleryGridLayout";
import TldrMediaTrimmingModal from "../../../common/TldrMediaTrimmingModal";
import { withTranslation } from "react-i18next";
import { onRejectFileDropzone } from "../../../../_utils/mimeType";
import { Box, Icon, Text, Tooltip } from "@chakra-ui/react";
import MusicItem from "../mediaPanel/AudioList/MusicItem";
import {
  getAssetMessageFromAssetProcessingStatus,
  getCursorTypeFromAssetProcessingStatus,
} from "../../../../_utils/mediaPanels";
import AssetsDropzone from "apps/simplified-web/src/TldrApp/AssetsDropzone";
import ImageIcon from "../../../../assets/icons/Vector.svg";
import { FaFolderPlus } from "react-icons/fa";

const dropTargetStyles = {
  position: "relative",
  "&.uppy-is-drag-over > [data-uppy-drag-overlay]": {
    position: "absolute",
    inset: "0",
    zIndex: 100,
    backgroundColor: "blackAlpha.900",
    border: "3px dashed",
    borderColor: "whiteAlpha.700",
    height: "100%",
    minHeight: ["85vh","85vh","89vh"],
    top: "0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "none",
    left: "-3",
  },
};

const contentWrapperStyles = {
  position: "relative",
};

const assetsStyles = {
  ".uppy-Dashboard-AddFiles-title:before": {
    backgroundImage: `url(${ImageIcon})`,
    content: "''",
    top: "40%",
    height: "24px",
    width: "32px",
    backgroundRepeat: "no-repeat",
    margin: "0 auto",
    textAlign: "center",
    display: "block",
    marginBottom: "0.75rem",
  },
  ".uppy-Dashboard-AddFiles-title": {
    fontSize: "0.8rem",
    fontWeight: 500,
    color: "white",
  },
  ".uppy-Dashboard-browse": {
    display: "block",
    margin: "0 auto",
    background: "var(--chakra-colors-whiteAlpha-100)",
    color: "white",
    textTransform: "capitalize",
    padding: "0.6rem",
    borderRadius: "8px",
    fontSize: "1rem",
    fontWeight: 700,
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
    width: "100%",
    textAlign: "center",
  },
  ".uppy-Dashboard-browse:hover": {
    boxShadow: "none",
    border: "none",
  },
};
class AssetsSliderPanel extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.addLayerCallback = this.addLayerCallback.bind(this);

    this.state = {
      mediaTrimmingData: {
        show: false,
        data: null,
        maxTrim: null,
        currentAudioRef: null,
      },
      visible: true,
    };
  }

  onPlayMusicItem = (audioEl) => {
    const { currentAudioRef } = this.state;
    if (currentAudioRef) {
      currentAudioRef.stop();
    }
    this.setState({
      currentAudioRef: audioEl.current,
    });
  };

  render() {
    const { mediaTrimmingData } = this.state;
    const { sidebarSlider, t } = this.props;
    const { loaded, payload, hasMore, counter } = sidebarSlider;
    const childElements = payload.map((asset) => {
      const payload = prepareAssetPayload(asset, this.props.activePage.id);

      const isActionAllowed = [
        AssetProcessingStatusTypes.DONE,
        AssetProcessingStatusTypes.THUMBNAIL_FAILED,
      ].includes(asset.status);

      let cursor = getCursorTypeFromAssetProcessingStatus(asset.status);
      let errorMessage = getAssetMessageFromAssetProcessingStatus(asset.status);
      return (
        <Tooltip
          hasArrow
          placement="top"
          label={t(errorMessage, { ns: "common" })}
          isDisabled={!errorMessage}
        >
          <Box
            key={asset.id}
            className="item item-asset"
            onClick={() => {
              if (isActionAllowed) {
                if (asset.asset_type !== "audio")
                  this.addLayerCallback(payload);
              }
            }}
            data-grid-groupkey={asset.groupKey || 1}
            cursor={cursor}
          >
            {asset.asset_type === "audio" ? (
              <MusicItem
                showContextMenu
                key={asset.id}
                data={{
                  ...payload,
                  title: payload?.title,
                  duration: payload?.duration,
                  cover: payload?.cover,
                  src: payload?.src,
                }}
                onClick={(e) => {
                  if (isActionAllowed) this.addLayerCallback(payload);
                }}
                onPlay={this.onPlayMusicItem}
                canDrag={isActionAllowed}
              />
            ) : (
              <ImageItem
                data={payload}
                key={asset.id}
                url={
                  asset.thumbnail_cover_image
                    ? asset.thumbnail_cover_image
                    : asset.thumbnail
                }
                alt={"asset"}
                width={asset.cover_image_width || 200}
                height={asset.cover_image_height || 200}
                source={"Simplified"}
                hasAction={true}
                type={"asset"}
                modalFor={"asset"}
                showOverlayInfo={false}
                isUsedInSwiper={false}
                canDrag={isActionAllowed}
              />
            )}
          </Box>
        </Tooltip>
      );
    });

    return (
      <>
        <Box
          className="assetDropbox"
          sx={{ ...contentWrapperStyles, ...dropTargetStyles }}
          mt="-1.2rem"
        >
          <Box data-uppy-drag-overlay display="none">
            <Icon
              as={FaFolderPlus}
              display="block"
              height="3rem"
              width="3rem"
              color="brand.safe_light"
            />

            <Text mt={4} color="white">
              {t("assets.drop_here", { ns: "folders" })}
            </Text>
          </Box>
          <Box mt={4}>
            <SearchForm searchPlaceholder={t("search.search_asset")} />
          </Box>
          <hr
            className="tldr-hr"
            style={{
              marginLeft: "4px",
              marginRight: "0px",
              width: `calc(100% - 24px)`,
            }}
          />

          <Box pr={4} mt={2}>
            <Box margin="auto" my={4} sx={assetsStyles}>
              <AssetsDropzone
                parentCallback={this.onAssetsDrop}
                isUploading={counter > 0}
                borderedDesign={false}
              />
            </Box>
          </Box>
          <Box flex={1} flexBasis={0} overflow={"hidden auto"} h={"100%"}>
            <TLDRInfiniteGalleryGridLayout
              hasMore={hasMore}
              loadPage={this.loadPage}
              className="asset-gallery"
              loaded={loaded}
            >
              {childElements}
            </TLDRInfiniteGalleryGridLayout>
          </Box>
          {loaded && childElements.length === 0 ? (
            <ShowNoContent text={t("search.upload_asset_msg")} />
          ) : (
            <></>
          )}

          {mediaTrimmingData && mediaTrimmingData.show && (
            <TldrMediaTrimmingModal
              show={mediaTrimmingData.show}
              onHide={this.resetTrimmingData}
              onSubmit={this.onSubmitTrim}
              data={mediaTrimmingData.data}
              mediaType={"Video"}
              maxTrimPercentage={mediaTrimmingData.maxTrim}
              defaultTrimPercentage={mediaTrimmingData.maxTrim}
              // canvasRef={canvasRef}
            />
          )}
        </Box>
      </>
    );
  }

  componentDidMount() {
    this.loadPage(1);
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  resetTrimmingData = () => {
    this.setState({
      mediaTrimmingData: {
        show: false,
        data: null,
        maxTrim: null,
      },
    });
  };

  getPageDuration = () => {
    const {
      editor: { activePage: { id } = {} },
      pages,
    } = this.props;
    const page = pages[id];
    if (page) {
      return page?.payload?.animation?.duration ?? DEFAULT_ARTBOARD_DURATION;
    }
    return DEFAULT_ARTBOARD_DURATION;
  };

  onAssetsDrop = (droppedFiles) => {
    if (droppedFiles.length > 0) {
      this.props.setCounter(droppedFiles.length);
    }
    droppedFiles.forEach((file) => {
      this.props.uploadFile(file, { ...this.props }, this.signal);
    });
    analyticsTrackEvent("dragNDropAssets");
  };

  loadPage = (groupKey) => {
    // There is no searchText then fetch general images and add into InfiniteGrid
    this.props.fetchData(this.props.sidebarSlider.source, {
      ...this.props,
      groupKey,
    });
  };

  onSubmitTrim = (startTime, endTime) => {
    const {
      mediaTrimmingData: { data },
    } = this.state;
    const updatedVideoData = {
      ...data,
      payload: {
        ...data.payload,
        startTime: startTime,
        endTime: endTime,
      },
    };
    this.resetTrimmingData();
    this.props.wsAddLayer(this.props.activePage.id, updatedVideoData);
  };

  addLayerCallback = async (item) => {
    const {
      story: { payload: { story_type } = {} } = {},
      editor: { activePage: { id: activePageId } = {} },
    } = this.props;
    const { action } = this.props.sidebarSlider;
    const { canvasRef } = this.props;

    if (action === REPLACE_META) {
      canvasRef.handler.imageHandler.replaceImageSource(
        item?.payload?.src,
        item?.payload?.userProperty,
        item?.content
      );
    } else if (action === REPLACE_BKG_IMAGE) {
      onClickSetAsBackground(canvasRef, item.content.url, item.content);
    } else if (action === ADD_MASK) {
      const activeTextObj = canvasRef.handler.canvas.getActiveObject();
      canvasRef.handler.maskHandler.replaceMaskImage(
        activeTextObj,
        item,
        { offsetX: 0, offsetY: 0 },
        "push"
      );
    } else {
      if (item.mime === "shape") {
        if (item.type === "icon") {
          let payload = item;
          if (!payload) {
            return;
          }
          this.props.wsAddLayer(this.props.activePage.id, payload);
        } else {
          this.props.wsCopyFromTemplate(
            this.props.activePage.id,
            item.content.id
          );
        }
      } else if (item.mime === "audio") {
        const { story } = this.props;
        const musicPayload = item;
        const payload = {
          ...musicPayload,
          action: "add",
        };

        batch(() => {
          if (story?.payload?.payload?.music) {
            this.props.wsUpdateMusic({
              ...story?.payload?.payload,
              music: payload,
            });
          } else {
            this.props.wsAddMusic({
              ...story?.payload?.payload,
              music: payload,
            });
          }
          this.props.closeSlider(); // close slider once music added
          this.props.updateStoryMusic(payload);
        });
      } else if (item.mime === "video") {
        this.props.wsAddLayer(this.props.activePage.id, item);
      } else if (item.content) {
        this.props.wsAddLayer(this.props.activePage.id, item);
      } else {
        this.props.wsCopyFromTemplate(this.props.activePage.id, item);
      }
    }
    if (this.props.isMobileView) {
      this.props.closeSlider();
    }
  };
}

AssetsSliderPanel.propTypes = {
  panelType: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired,
  sidebarSlider: PropTypes.object.isRequired,
  editor: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  panelType: state.sidebarSlider.sliderPanelType,
  sidebarSlider: state.sidebarSlider,
  editor: state.editor,
  page: state.sidebarSlider.page,
  activePage: state.editor.activePage,
  story: state.story,
  auth: state.auth,
  subscription: state.subscription,
  pages: state.pagestore?.pages,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  fetchData: (source, props) => dispatch(fetchData(source, props)),
  wsAddLayer: (activePageId, payload) =>
    dispatch(wsAddLayer(activePageId, payload)),
  uploadFile: (file, props, signalToken) =>
    dispatch(uploadFile(file, props, signalToken)),
  setCounter: (counter) => dispatch(setCounter(counter)),
  wsAddMusic: (payload) => dispatch(wsAddMusic(payload)),
  wsUpdateMusic: (payload) => dispatch(wsUpdateMusic(payload)),
  updateStoryMusic: (musicData) => dispatch(updateStoryMusic(musicData)),
  closeSlider: () => dispatch(closeSlider()),
  openSlider: (panel) => dispatch(openSlider(panel)),
});

export default withTranslation(["common", "folders"])(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(AssetsSliderPanel))
);
